const { Core, Utils, Events } = Global;
const { $toggleDisplay, $state } = Utils;

customElements.define('product-dynamic-checkout', class extends Core {
    upsellProductsCount = 0;
    
    render() {
        this._rerenderPaymentButton();
        this._fixMorePaymentOptions();
        this.sub(Events.CART_ADD, this._disable, { global: true });
        this.sub(Events.PRODUCT_FORM_SUBMIT, this._disable, { global: true });
        this.sub(Events.CART_CHANGE, this._enable, { global: true });
        this.sub(Events.CART_UPDATE, this._enable, { global: true });
        this.sub(Events.CART_ERROR, this._enable, { global: true });
    }

    _rerenderPaymentButton() {
        if (window.Shopify?.PaymentButton?.init) {
            window.Shopify.PaymentButton.init();
        }
    };

    _fixMorePaymentOptions() {
        // Fallback: Leitet "Weitere Bezahlmoeglichkeiten" zum Checkout weiter,
        // falls Shopify's Web Component den Klick nicht abfaengt.
        setTimeout(() => {
            const link = this.querySelector('#more-payment-options-link');
            if (!link || link.getAttribute('href') !== '#') return;
            
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                const form = this.closest('form');
                if (!form) return;
                const variantId = form.querySelector('input[name=\"id\"]')?.value;
                const quantity = form.querySelector('input[name=\"quantity\"]')?.value || 1;
                if (!variantId) return;
                
                try {
                    await fetch('/cart/add', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: variantId, quantity: parseInt(quantity) })
                    });
                    window.location.href = '/checkout';
                } catch (err) {
                    window.location.href = '/checkout';
                }
            });
        }, 500);
    };

    _disable() {
        this.disabled = true;
    }

    _enable() {
        setTimeout(() => {
            this.disabled = false
        }, 1500);
    };

    set disabled(state) {
        $state(this, 'disabled', state);
    };
});
